import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';
import { Table, Typography, message, Spin, Modal, Button, Popconfirm } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import efn from './ConferencesFns.js'
import ConferenceFeatures from './ConferenceFeatures.js'
import './Conferences.scss';
const { Text } = Typography;
function Conference(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const [conferencesMode, setConferencesMode] = useState("conferences")
  const [conferences, setConferences] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [conferenceSetting, setConferenceSetting] = useState({
    isOpen: false
  })
  const [waitUpdateData, setWaitUpdateData] = useState({ before: null, after: null })
  const setFuncMap = { setConferences, setIsPageLoading, setIsTableLoading, setIsModalOpen, setConferenceSetting, setWaitUpdateData }
  const columnsParams = {
    conferences, setFuncMap, location, navigate, getReferenceByUid: efn.getReferenceByUid
  }
  const columns = efn.generateConferenceColumns(columnsParams)

  useEffect(() => {
    efn.getConferences(setFuncMap, conferencesMode)
    props.setContentHeader(<></>)

  }, [conferencesMode]);

  return (
    <Spin spinning={isPageLoading}>
      <div className="Conferences">
        <Spin spinning={isTableLoading}>
          <div className="control-area">
            {conferencesMode === "conferences" ?
              <Button className="go-archive-btn" onClick={() => {
                setConferencesMode("archive")
              }}>查看封存</Button> :
              <div><Button className="back-to-conferences-btn" onClick={() => {
                setConferencesMode("conferences")
              }}>返回研討會列表</Button>已封存的研討會</div>}
          </div>
          <Table dataSource={conferences} columns={columns} />
        </Spin>
        <Modal title="變更研討會名稱" open={isModalOpen}
          onOk={() => {
            efn.updateReferenceNameByUid({
              waitUpdateData, conferences
            }, setFuncMap)
          }}
          onCancel={() => { setIsModalOpen(false) }}>
          {`${waitUpdateData.before} => ${waitUpdateData.after}`}
        </Modal>
        <Modal title={`${conferenceSetting.title} 設置`} open={conferenceSetting.isOpen}
          className="conference-modal-setting"
          okButtonProps={{ style: { display: 'none' } }}
          cancelButtonProps={{ style: { display: 'none' } }}
          onOk={() => { setConferenceSetting({ isOpen: false }) }}
          onCancel={() => { setConferenceSetting({ isOpen: false }) }}>
          <ConferenceFeatures
            conferenceSetting={conferenceSetting}
            setFuncMap={setFuncMap}
            conferencesMode={conferencesMode} />
          {/* <Popconfirm
            placement="left"
            title={`確認要封存: ${conferenceSetting.title}?`}
            onConfirm={() => { efn.archiveConferenceByUid(conferenceSetting, setFuncMap, conferencesMode) }}
            okText="Yes"
            cancelText="No"
          ><Button className="archive-btn"
            loading={conferenceSetting.archiveIsLoading}>封存</Button>
          </Popconfirm>
          <Popconfirm
            placement="left"
            title={`確認要複製 ${conferenceSetting.title}?`}
            onConfirm={() => { efn.copyConferenceByUid(conferenceSetting, setFuncMap, conferencesMode) }}
            okText="Yes"
            cancelText="No"
          ><Button className="copy-btn"
            loading={conferenceSetting.copyIsLoading}>複製</Button>
          </Popconfirm>

          <Popconfirm
            placement="left"
            title={`確認要複製 ${conferenceSetting.title}?`}
            onConfirm={() => { efn.copyConferenceByUid(conferenceSetting, setFuncMap, conferencesMode) }}
            okText="Yes"
            cancelText="No"
          ><Button className="copy-btn"
            loading={conferenceSetting.copyIsLoading}>複製</Button>
          </Popconfirm> */}

        </Modal>
      </div>
    </Spin>
  );
}


export default Conference;
